import React from 'react';
import { Grid, IconButton } from '@mui/material';
import { Domain as IndustryIcon, Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import { TextField } from '../../CommonComponents/Form';
import { SectionDivider } from '../../CommonComponents';
import METADATA_TYPES from '../../../types/MetadataType';
import { isInputAlreadyInList } from '../../../utils/metadata';

interface Industry { id: string; value: string; }

interface IndustryBlockProps {
    entity: any;
    onChange: (e: any) => void;
    industries: Industry[];
    setterIndustries: (industries: Industry[]) => void;
}

const IndustryBlock = ({
    entity,
    onChange,
    industries,
    setterIndustries
}: IndustryBlockProps) => {
    const addIndustry: (key: string) => void = () => {
        setterIndustries([...industries, { id: `custom-ind-${Date.now().toString()}`, value: '' }]);
    };

    const removeIndustry = (
        { key, valueId }
            : { key: string; valueId: string }
    ) => {
        const item = industries.find((i) => i.id === valueId);
        const newItems = industries.filter((i) => i.id !== valueId);

        setterIndustries(newItems);

        if ((item as any)?.value && entity.industries?.includes((item as any).value)) {
            onChange({
                ...entity,
                [key]: entity.industries.filter((p: string) => p !== (item as any).value)
            });
        }
    };

    const changeIndustry = (
        { key, propId, newValue }
            : { key: string; propId: string; newValue: string }
    ) => {
        const item = industries.find((i) => i.id === propId);
        const oldValue = (item as any)?.value;
        // eslint-disable-next-line no-confusing-arrow
        const newItems = industries.map((i) => i.id === propId ? { ...i, value: newValue } : i);
        setterIndustries(newItems);

        const updatedValues = [...(entity.industries || [])];

        if (oldValue) {
            const oldIndex = updatedValues.indexOf(oldValue);
            if (oldIndex > -1) {
                updatedValues.splice(oldIndex, 1);
            }
        }

        if (newValue && !updatedValues.includes(newValue)) {
            updatedValues.push(newValue);
        }

        onChange({
            ...entity,
            [key]: updatedValues
        });
    };
    return (
        <Grid item lg={12} xl={6}>
            <SectionDivider
                label={`Brancher (${entity.industries?.length || 0})`}
                icon={<IndustryIcon fontSize="small" />}
                marginTop={2}
                marginBottom={0}
            />
            <Grid container spacing={2}>
                {industries.map((ind) => (
                    <Grid item xs={12} key={ind.id} container spacing={1} alignItems="center">
                        <Grid item xs>
                            <TextField
                                name={`${ind.id}`}
                                label="Egen branch"
                                value={ind.value}
                                onChange={(e) => {
                                    const newValue = e.target ? e.target.value : (e[`custom-ind-${ind.id}`] ?? '');
                                    changeIndustry({ key: METADATA_TYPES.INDUSTRIES, propId: ind.id, newValue });
                                }}
                                required
                                customValidations={
                                    {
                                        isValid: !isInputAlreadyInList({
                                            id: ind.id,
                                            value: ind.value,
                                            list: industries
                                        }),
                                        errorText: 'Denna branch finns redan i listan'
                                    }
                                }
                                disabled={ind.id.startsWith('init-')}
                            />
                        </Grid>
                        <Grid item>
                            <IconButton
                                onClick={() => removeIndustry({
                                    key: METADATA_TYPES.INDUSTRIES,
                                    valueId: ind.id
                                })}
                                color="error"
                                size="small"
                            >
                                <RemoveIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                ))}
                <Grid item xs={12}>
                    <IconButton
                        onClick={() => addIndustry(METADATA_TYPES.INDUSTRIES)}
                        color="primary"
                        size="small"
                    >
                        <AddIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default React.memo(IndustryBlock);
